import { UserCMS } from '@/domain/entities/adminCMS'
import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
} from 'vuex-module-decorators'
import { container } from 'tsyringe'
import { AdminCMSPresenter } from '@/app/ui/presenters/AdminCMSPresenter'
import router from '@/router'
import store from '@/app/store/store'
import {
  CreateAdminCMSRequest,
  DeleteAdminRequest,
  UpdateAdminCMSRequest,
} from '@/data/payload/api/AdminCMSRequest'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface AdminCMSUI {
  AdminCMSData: UserCMS
  RoleCMSData: Array<Record<string, number | string>>
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'AdminCMS' })
class AdminCMSS extends VuexModule implements AdminCMSUI {
  public isLoading = true
  public AdminCMSData = new UserCMS(true, '', [])
  public RoleCMSData = [] as Array<Record<string, number | string>>
  public Pages = 0
  public Limit = 10
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'id',
      type: 'asc',
    },
    search: '',
  }
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'name', sortable: true },
    { key: 'email', sortable: true },
    { key: 'roleName', sortable: false },
    { key: 'lastLogin', sortable: false },
    { key: 'actions', sortable: false },
  ]

  @Action
  public async getAdminCMSData() {
    this.setLoading(true)
    const presenter = await container.resolve(AdminCMSPresenter)
    presenter
      .loadAdminCMS(this.paginationParam)
      .then((res: UserCMS) => {
        this.setLoading(false)
        this.setUserData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data CMS', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
  }

  @Action
  public async getListRole() {
    this.setLoading(true)
    const presenter = await container.resolve(AdminCMSPresenter)
    presenter
      .loadAdminRole(this.paginationParam)
      .then((res: Array<Record<string, number | string>>) => {
        this.setLoading(false)
        this.setRoleData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data CMS', res)
      })
      .catch((error) => {
        this.setLoading(false)
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        console.error('error', error)
      })
  }

  @Action
  public async createAdminCMS(params: {
    name: string
    email: string
    password: string
    sales_code: string
    role_id: number
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(AdminCMSPresenter)
    presenter
      .postAdminCMS(
        new CreateAdminCMSRequest(
          params.name,
          params.email,
          params.password,
          params.sales_code,
          params.role_id
        )
      )
      .then((res) => {
        //  console.log('data berhasil', res)

        Vue.prototype.$notify({
          title: 'User',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getAdminCMSData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateUser(params: {
    id: number
    name: string
    email: string
    password: string
    role_id: number
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(AdminCMSPresenter)
    presenter
      .updateUser(
        new UpdateAdminCMSRequest(
          params.name,
          params.email,
          params.password,
          params.role_id
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'User',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getAdminCMSData()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'User',
          message: 'Failed',
          type: 'error',
          duration: 5000,
        })
      })
  }

  @Action
  public async deleteUser(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(AdminCMSPresenter)
    presenter
      .deleteUser(new DeleteAdminRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'User',
          message: res.message,
          type: 'success',
          duration: 5000,
        })
        this.getAdminCMSData()
      })
      .catch((error) => {
        this.setLoading(false)
        Vue.prototype.$notify({
          title: 'User',
          message: 'Failed to delete',
          type: 'error',
          duration: 5000,
        })
        //  console.log(error)
      })
  }

  @Mutation
  private setUserData(AdminCMS: UserCMS) {
    this.AdminCMSData = AdminCMS
  }

  @Mutation
  private setRoleData(Role: Array<Record<string, number | string>>) {
    this.RoleCMSData = Role
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }

  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}
export const AdminCMSModule = getModule(AdminCMSS)
